import { css } from 'linaria';
export const buttonReset = "b5bt6fr";

require("../../../.linaria-cache/src/components/buttons/button-reset.linaria.module.css");